module.exports = {
  OperationFailed: 'Operation failed',
  SelectTime: 'Select Time',
  FeeRefund: '(Fee refund)',
  TheHasExpiredNoCreated: 'The contract of this commissioning unit has expired, no new business can be created',
  DueCannotBePrintedNeeded: 'Due to credit control exceeding, this bill has been locked and cannot be printed or EDI, please contact the superior to unlock when needed!',
  ItPrintedPleaseContactUnlock: ' It has been locked and cannot be printed, please contact the superior manager to unlock!',
  AttachmentContentIsTooLarge: ' Attachment content is too large',
  Unknown: 'Unknown',
  YourWeightAndVolumeTo: 'Your cargo has participated in data comparison, and automatic packing will update the weight and volume information of this bill and the master bill it belongs to.',
  Tip: 'Tip',
  GotIt: 'Got it',
  AddNew: 'Add New',
  PleaseSelectTheSpecifiedData: 'Please select the specified data',
  LicenseOfLadingNumberEmpty: 'License plate number and bill of lading number cannot be empty',
  IntegratedLogisticsCargoDetails: 'Integrated Logistics Cargo Details',
  PleaseAPieceOfData: 'Please select a piece of data!',
  Mbl: 'CMR NO.'
}
